import { render, staticRenderFns } from "./DocFaceContrast.vue?vue&type=template&id=1db7b9ed&scoped=true"
import script from "./DocFaceContrast.vue?vue&type=script&lang=js"
export * from "./DocFaceContrast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7b9ed",
  null
  
)

export default component.exports